export const CHALLENGE_STATUSES = {
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CHALLENGED: "Challenged"
};

export const CHALLENGE_TYPES = {
  ADD_ACCOUNT: "AddAccount",
  ADD_TARGET: "AddTarget",
  REMOVE_ACCOUNT: "RemoveAccount",
  REMOVE_TARGET: "RemoveTarget",
  EDIT_GOAL: "EditGoal",
  KEEP_ACCOUNT: "KeepAccount",
  GOAL_EDIT: "GoalEdit"
};

export const ACCOUNT_CHANGE = {
  ADDED: "ADDED",
  DROPPED: "DROPPED",
  NO_CHANGE: "NO_CHANGE"
};

export const ALIGN_TYPES = {
  STRING: "STRING",
  BOOLEAN: "BOOLEAN",
  DATE: "DATE",
  DATETIME: "DATETIME",
  NUMBER: "NUMBER"
};

export const NULL_DISPLAY_STRING = "-";

export const GEO_TYPES = {
  POSTAL_CODE: "POSTAL_CODE",
  BRICK: "BRICK"
};
